import axios from "axios";
import router from '@/router';
import store from '@/store';


const instance = axios.create({
    baseURL: require('../../settings.json').apiBackend,
    headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}`}
});
//instance.defaults.headers.common['Authorization'] = localStorage.getItem('user-token');
//http://apoyo.ferreteriaonlinehoyostools.co/public/index.php/api/ http://127.0.0.1:8000/api/

// Configurar el interceptor de respuesta
instance.interceptors.response.use(
    response => {
      return response;
    },
    async error => {
        if (error.response) {
            if (error.response.status === 401) {
              // Token inválido o expirado
              await store.dispatch('auth/logout'); // Llamar a la acción logout
              router.push('/'); // Redirigir al login
            } else if (error.response.status === 403) {
              router.push('/dash/inicio'); // Redirigir a una página de acceso denegado
            }
          }
      return Promise.reject(error);
    }
  );

export default instance;